import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { activeSnack } from './common';
import { del, get, put, post } from '../http';
import { covertToJSON } from '../../utils/stateToJson';

// --- API THUNKS START ---
export const createMemberClub = createAsyncThunk(
  'member-club/create',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/member_club/admin/new`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(activeSnack({ type: 'success', message: 'Member Club created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllMemberClubs = createAsyncThunk(
  'member-club/list',
  async ({ page, search, dispatch, limit }) => {
    try {
      const response = await get(
        `/member_club/admin/all?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getMemberClubDetails = createAsyncThunk(
  'member-club/single',
  async ({ memberClubId, dispatch }) => {
    try {
      const response = await get(`/member_club/admin/${memberClubId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const updateMemberClubDetails = createAsyncThunk(
  'member-club/update',
  async ({ state, memberClubId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/member_club/admin/${memberClubId}`;
      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        dispatch(activeSnack({ type: 'success', message: 'Member Club updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const deleteMemberClub = createAsyncThunk(
  'member-club/delete',
  async ({ memberClubId, dispatch, handleCloseDeleteDialog }) => {
    try {
      const response = await del(`/member_club/admin/${memberClubId}/`);
      if (response) {
        handleCloseDeleteDialog();
        dispatch(activeSnack({ type: 'success', message: 'Member Club deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const createMemberClubWithdrawalRequest = createAsyncThunk(
  '/memberClub/withdrawal',
  async ({ state, dispatch, club, handleNextStep, setOpenWalletTransferSuccess, handleClose }) => {
    try {
      const URL = `/memberClub/withdrawal/${club}`;
      const response = await post(URL, state);
      if (response) {
        if (handleNextStep) {
          handleNextStep();
        }
        if (handleClose) {
          handleClose();
        }
        if (setOpenWalletTransferSuccess) {
          setOpenWalletTransferSuccess(true);
        }
        dispatch(
          activeSnack({
            type: 'success',
            message: 'Transfer to personal wallet completed successfully',
          })
        );
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllMemberClubsForMember = createAsyncThunk(
  'member-club/member/list',
  async ({ page, search, limit, dispatch }) => {
    try {
      const response = await get(
        `memberClub/member/all?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
export const memberClubSlice = createSlice({
  name: 'memberClub',
  initialState: {
    loading: false,
    error: {},
    // staff
    memberClubs: {},
    memberClubDetails: {},
    memberClubWithdrawalRequests: {},
    memberClubsForMember: {},
  },
  reducers: {
    clearStaffError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    [createMemberClub.pending]: (state) => {
      state.loading = true;
    },
    [createMemberClub.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.memberClubs;
      const newList = jsonState?.memberClubs;
      const modifiedList = {
        ...jsonState,
        memberClubs: Array.isArray(newList) ? [action.payload, ...newList] : [action.payload],
      };
      state.loading = false;
      state.memberClubs = modifiedList;
      state.error = {};
    },
    [createMemberClub.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getAllMemberClubs.pending]: (state) => {
      state.loading = true;
    },
    [getAllMemberClubs.fulfilled]: (state, action) => {
      state.loading = false;
      state.memberClubs = action.payload;
      state.error = {};
    },
    [getAllMemberClubs.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [getMemberClubDetails.pending]: (state) => {
      state.loading = true;
    },
    [getMemberClubDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.memberClubDetails = action.payload;
      state.error = {};
    },
    [getMemberClubDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [updateMemberClubDetails.pending]: (state) => {
      state.loading = true;
    },
    [updateMemberClubDetails.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.memberClubs;
      const modifiedList = {
        ...jsonState,
        memberClubs: jsonState.memberClubs?.map((i) =>
          i._id === action.payload._id ? action?.payload : i
        ),
      };

      state.loading = false;
      state.memberClubs = modifiedList;
      state.error = {};
    },
    [updateMemberClubDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteMemberClub.pending]: (state) => {
      state.loading = true;
    },
    [deleteMemberClub.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.memberClubs;
      const modifiedList = {
        ...jsonState,
        memberClubs: jsonState.memberClubs?.filter((member) => member._id !== action.payload),
      };
      state.loading = false;
      state.memberClubs = modifiedList;
      state.error = {};
    },
    [deleteMemberClub.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [createMemberClubWithdrawalRequest.pending]: (state) => {
      state.loading = true;
    },
    [createMemberClubWithdrawalRequest.fulfilled]: (state, action) => {
      state.memberClubWithdrawalRequests = action.payload;
      console.log('payload', action.payload);
      state.loading = false;

      state.error = {};
    },
    [createMemberClubWithdrawalRequest.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    [getAllMemberClubsForMember.pending]: (state) => {
      state.loading = true;
    },
    [getAllMemberClubsForMember.fulfilled]: (state, action) => {
      state.loading = false;
      state.memberClubsForMember = action.payload;
      state.error = {};
    },
    [getAllMemberClubsForMember.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearStaffError } = memberClubSlice.actions;

export default memberClubSlice.reducer;
